import React from 'react';
import { ChakraProvider, Box, Text, VStack, theme, Table, Thead, Tbody, Tr, Th, Td, Link } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function App() {
  const data = {
    labels: ['Replicate', 'Together', 'Perplexity'],
    datasets: [
      {
        label: 'Average Tokens per Second',
        data: [9.73, 48.37, 32.82],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'LLM Cloud Service Perf Benchmark',
      },
    },
  };

  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" fontSize="xl">
        <VStack spacing={8}>
          <Text>Llama 2 70b throughput (tokens per second)</Text>
          <Box width="50%">
            <Bar data={data} options={options} />
          </Box>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Service</Th>
                <Th isNumeric>Avg Tokens per Second</Th>
                <Th isNumeric>Standard Deviation</Th>
                <Th>Documentation</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>Replicate</Td>
                <Td isNumeric>9.73</Td>
                <Td isNumeric>0.84</Td>
                <Td><Link href="https://replicate.com/docs" isExternal>Replicate Docs</Link></Td>
              </Tr>
              <Tr>
                <Td>Together</Td>
                <Td isNumeric>48.37</Td>
                <Td isNumeric>10.62</Td>
                <Td><Link href="https://docs.together.ai/docs/quickstart" isExternal>Together Docs</Link></Td>
              </Tr>
              <Tr>
                <Td>Perplexity</Td>
                <Td isNumeric>32.82</Td>
                <Td isNumeric>1.32</Td>
                <Td><Link href="https://docs.perplexity.ai/" isExternal>Perplexity Docs</Link></Td>
              </Tr>
            </Tbody>
          </Table>
        </VStack>
      </Box>
    </ChakraProvider>
  );
}

export default App;
